import { ActualizationCandidate } from '../../api/model-service/actualization';
import { uniq } from 'lodash';

export function countCandidateModels(candidates: ActualizationCandidate[]): number {
    const opportunityNumbers = candidates.map(candidate => candidate.opportunityNumber);
    return uniq(opportunityNumbers).length;
}
